"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uniqueId;
var uid = 0;

function uniqueId() {
    return uid++;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-textfit/lib/utils/uniqueId.js
// module id = 928
// module chunks = 35783957827783